import { useState, useEffect, useRef } from "react";
// Import the React Bootstrap components
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import { Link, useLocation } from "react-router-dom";

import logo from "../../assets/tsm.png";

export default function CustomNavbar() {
  const [open, setOpen] = useState(false);
  const [hidden, setHidden] = useState(false);
  const [navHeight, setNavHeight] = useState(0);

  const lastScrollY = useRef(0);
  const navbarRef = useRef(null);

  // 1. Calculate dynamic navbar height based on text wrapping
  useEffect(() => {
    if (navbarRef.current) {
      setNavHeight(navbarRef.current.offsetHeight);
    }

    const handleResize = () => {
      if (navbarRef.current) {
        setNavHeight(navbarRef.current.offsetHeight);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 2. Hide navbar on scroll down, show on scroll up (mobile only)
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (window.innerWidth < 992) {
        // 992px matches Bootstrap's expand="lg" mobile breakpoint
        // If mobile menu is open, don't hide the navbar while scrolling
        if (open) return;

        if (
          currentScrollY > lastScrollY.current &&
          currentScrollY > navHeight
        ) {
          setHidden(false); // Scrolling down
        } else {
          setHidden(false); // Scrolling up
        }
      } else {
        setHidden(false); // Always visible on desktop
      }

      lastScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [navHeight, open]);

  return (
    <>
      <div
        ref={navbarRef}
        className="fixed-top transition-transform"
        style={{
          transform: hidden ? `translateY(-${navHeight}px)` : "translateY(0px)",
          transition: "transform 0.3s ease-in-out",
          zIndex: 1030,
        }}
      >
        <Navbar bg="white" expand="lg" className="py-3 shadow-sm">
          <Container className="px-4">
            <Navbar.Brand
              as={Link} to="/"
              className="d-flex align-items-center p-0 m-0"
              style={{ maxWidth: "fit-content" }}
            >
              {/* Tushar Suryawanshi
              <br />
              Management Pvt Ltd */}
              <img
                src={logo}
                alt="Logo"
                style={{ height: "32px", width: "auto", display: "block" }}
                // style={{ maxHeight: "40px", width: "auto", objectFit: "contain" }}
              />
            </Navbar.Brand>

            {/* Mobile menu toggle button */}
            <Navbar.Toggle
              aria-controls="basic-navbar-nav"
              className="ms-auto"
              onClick={() => setOpen(!open)}
            />

            {/* Middle & Right Side Content */}
            <Navbar.Collapse id="basic-navbar-nav" in={open}>
              {/* Centered Navigation Links */}
              <Nav className="mx-auto text-center gap-3">
                <Nav.Link
                  href="#home"
                  onClick={() => setOpen(false)}
                  className="text-success fw-medium"
                >
                  Home
                </Nav.Link>
                <Nav.Link
                  href="#about"
                  onClick={() => setOpen(false)}
                  className="text-secondary fw-medium"
                >
                  About
                </Nav.Link>
                <Nav.Link
                  href="#services"
                  onClick={() => setOpen(false)}
                  className="text-secondary fw-medium"
                >
                  Services
                </Nav.Link>
                <Nav.Link
                  href="#stats"
                  onClick={() => setOpen(false)}
                  className="text-secondary fw-medium"
                >
                  Stats
                </Nav.Link>
                <Nav.Link
                  href="#contact"
                  onClick={() => setOpen(false)}
                  className="text-secondary fw-medium"
                >
                  Contact
                </Nav.Link>
               
              </Nav>

              {/* Right Side: Auth Buttons */}
              <div className="d-flex align-items-center justify-content-center gap-3 mt-3 mt-lg-0">
                {/* <Button
                  variant="link"
                  className="text-dark text-decoration-none fw-medium p-0"
                >
                  Sign in
                </Button> */}

                <Button
                  style={{color:"#405189", backgroundColor: "#e2e5ed",border: "none" }}
                  className="px-4 py-2 fw-medium shadow-sm"
                  href="https://tsmofficial.com/login"
                >
                  <i className="bi bi-person me-2"></i>
                  Login
                </Button>
              </div>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>

      {/* 3. DYNAMIC SPACER: Automatically matches navbar's real height to push the hero down */}
      <div style={{ height: `${navHeight}px` }} className="w-100" />
    </>
  );
}
